import React, { Component } from 'react';
import Constants from '../../Config/Config';

class BottomMat extends Component {
	render() {
		const {bottomMatTotal, selectedBottomMat, selectedMatSize} = this.props;
    return (
      <tr>
        <th>Bottom Mat</th>
          <td>{selectedBottomMat.getIn(['title', 'rendered']) !== undefined && parseFloat(selectedMatSize) === 3 ? selectedBottomMat.getIn(['title', 'rendered']) : "None Selected"}</td> 
          <td>{Constants.Currency}{parseFloat(selectedMatSize) === 3 ? bottomMatTotal : '0'}</td>
      </tr>
    );
	}
}
export default BottomMat;